/* istanbul ignore file: will be tested later */
import loadable from '@wix/yoshi-flow-editor/loadable';

export const LazyRichContentViewer = loadable(
  () => import(/* webpackChunkName: "LazyRichContentViewer" */ './RichContentViewer'),
  {
    resolveComponent: (components) => components.RichContentViewer,
  }
);
